'use strict';

export class Profile {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		this.$dropdown = jQuery('.js-profile_actions');
		this.$menu_buttons = jQuery('.js-profile_menu_action');
		this.$actions = jQuery('.js-profile_action');
	}
	
	init() {
		this.add_events();
	}
	add_events() {
		jQuery('body').on('click', '.js-profile_menu_action', this.menu_button_click_handler.bind(this));
		jQuery('body').on('click', '.js-profile_action', this.menu_action_item_click_handler.bind(this));
	}
	menu_button_click_handler(profile_context, event) {
		yalwa.basics.bem_modifier(this.$dropdown, 'active', 'toggle');
	}
	menu_action_item_click_handler(event, context) {
		if (!yalwa.basics.readonly_check()) {
			return false;
		}
		this.action_context = context;
		const $element = jQuery(event.currentTarget);
		this.action = $element.data('action');
		if (this.action_context !== 'via_contact_form') {
			yalwa.basics.bem_modifier(this.$dropdown, 'active', 'toggle');
		}
		switch(this.action) {
			case 'block':
				this.api = '/api/ajax/ignore_user';
				this.send_data = {
					ignore: 1,
					emailID: $element.data('emailid')
				}
				break;
			case 'unblock':
				this.api = '/api/ajax/ignore_user';
				this.send_data = {
					ignore: 0,
					emailID: $element.data('emailid')
				}
				break;
			case 'unfollow':
			case 'follow':
				this.api = '/api/ajax/follow_user';
				this.send_data = {
					action: this.action,
					userID: $element.data('userid')
				};
				break;
			case 'flag':
				jQuery('.js-plp_flag_user').trigger('plp_show');
				return;

		}
		this.ajax_call().done(this.ajax_response_handler.bind(this, $element));
	}
	ajax_call() {
		return jQuery.ajax({
			url: this.api,
			type: 'post',
			dataType: 'json',
			data: this.send_data
		});
	}
	
	ajax_response_handler($element, response) {
		let other_button_action = 'follow';
		let menu_button_action = 'follow';
		const $profile_postings = jQuery('.js-hidden_for_blocked');
		const $ignored_ads = jQuery('.js-bst_list_item');
		const $block_message = jQuery('.js-block_message');
		switch(this.action) {
			case 'unblock':
				other_button_action = 'block';
				menu_button_action = this.component.followed ? 'following' : 'follow';
				yalwa.basics.show($profile_postings);
				yalwa.basics.show($ignored_ads); // fallback
				yalwa.basics.hide($block_message);
				break;
			case 'block':
				other_button_action = 'unblock';
				menu_button_action = 'unblock';
				yalwa.basics.hide($profile_postings);
				yalwa.basics.show($block_message);
				break;
			case 'follow':
				other_button_action = 'unfollow';
				menu_button_action = 'following';
				this.component.followed = true;
				this.update_followers_counter(1);
				break;
			case 'unfollow':
				other_button_action = 'follow';
				menu_button_action = 'follow';
				this.component.followed = false;
				this.update_followers_counter(-1);
				break;
			case 'flag':
				break;
		}
		if (response.success) {
			if (this.action_context !== 'via_contact_form') {
				yalwa.basics.toast({message: $element.data('message'), type: 'success'});
			}
			yalwa.basics.toggle($element);
			if (this.action === 'block') {
				this.$actions.not('.hidden').addClass('js-was_visible_on_block');
				yalwa.basics.hide(this.$actions);
			} else {
				yalwa.basics.show(this.$actions.filter('.js-was_visible_on_block'));
				this.$actions.filter('.js-was_visible_on_block').removeClass('js-was_visible_on_block');
			}
			yalwa.basics.toggle(this.$actions.filter(`[data-action="${other_button_action}"]`));
			yalwa.basics.hide(this.$menu_buttons);
			yalwa.basics.show(this.$menu_buttons.filter(`[data-action="${menu_button_action}"]`));
		} else {
			yalwa.basics.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
		}
	}
	update_followers_counter (count) {
		const $followers_counter = jQuery('.js-followers_counter');
		$followers_counter.html(parseInt($followers_counter.html()) + parseInt(count));
	}
}
Object.keys(yalwa.v.components).map(component_key => {
	if (component_key.startsWith('profile_')) {
		new Profile(component_key).init();
	}
})

